export default async function UpdateMetabaseCodeApi(
  positionId,
  payload,
  performanceCycleId
) {
  let res = "";
  try {
    const body = {
      positionId: positionId,
      metabaseCode: payload,
      performanceCycleId: performanceCycleId,
    };
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
      body: JSON.stringify(body),
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/position-metabase`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error updating metabase payload: ", error);
        res = error;
      });
  } catch (error) {
    console.error(error);
    res = error;
  }

  return res;
}
